import { deletePeriod, createPeriod } from "./asyncThunks";

export const deletePeriodBuilder = (builder) => {
  builder.addCase(deletePeriod.fulfilled, (state, action) => {});
};

export const createPeriodBuilder = (builder) => {
  builder.addCase(createPeriod.fulfilled, (state, action) => {});
};
